/**
 * Builds a URL
 *
 * @param {string} link
 *   The base link
 * @param {string} keyvalue
 *   Any GET params
 *
 * @return {string}
 *   The build URL
 */
const buildUrl = (link, keyvalue) => {
  let paramList = [];
  const existingParams = link.split("?");

  // Build an object with any existing query params
  if (existingParams.length === 2) {
    paramList = existingParams[1].split("&").map((index, value) => {
      const temp = value.split("=");

      if (temp[0] !== "") {
        return { name: temp[0], value: temp[1] };
      }

      return null;
    });
  }

  // Replace pc if it exists, otherwise just add it to the param list
  // Should add this to a function maybe?
  const l = paramList.map((obj, index) => {
    if (obj.name === "pc") {
      return index;
    }

    return null;
  });

  if (l.length > 0) {
    paramList[l[0]] = keyvalue;
  } else {
    paramList.push(keyvalue);
  }

  return `${existingParams[0]}?${paramList.map(
    (value) => `${value.name}=${value.value}`
  )}`;
};

export default buildUrl;
